import { type Option } from "~/core/models/filters";
import type { DtwinDistinctValues } from "~/modules/dtwin/models/DtwinDistinctValues.interface";
import type { DtwinLifeCycleState } from "~/modules/dtwin/models/DtwinLifeCycleState.enum";
import { getLifeCycleStateProperties } from "~/modules/dtwin/utils/getLifeCycleStateProperties";

export function getLifeCycleStatesOptions(
  translate: (key: string) => string,
  translateCheck: (key: string) => boolean,
  distinctValues?: DtwinDistinctValues,
) {
  let lifecycles: Option[] = [];

  if (distinctValues?.lifeCycleState) {
    lifecycles = distinctValues.lifeCycleState?.map(
      (state: DtwinLifeCycleState) => {
        return {
          label: getLifeCycleStateProperties(state, translate, translateCheck)
            .label!,
          value: state,
        };
      },
    );
  }

  // group values by lifecycle label
  const lifecyclesGroupedByLabel = lifecycles.reduce(
    (acc, lifecycle) => {
      acc[lifecycle.label] = (acc[lifecycle.label] || []).concat(
        lifecycle.value,
      );
      return acc;
    },
    {} as Record<string, string[]>,
  );

  return {
    label: translate("dtwins.filters.lifecycleState"),
    options: Object.entries(lifecyclesGroupedByLabel).map(
      ([label, values]) => ({
        label,
        value: values.join(","),
      }),
    ),
  };
}
